import { BaseController } from './controller';
import _ from 'lodash';

export class BaseTicketController extends BaseController {
  constructor(injections, options) {
    super(injections, options);

    // Ensure that the mandatory ticketSevice has been injected
    this.constructor.contractInjection(this, 'ticketService');

    this.cancelListeners = [];
  }

  $onInit() {
    // NOTE: ALL DERIVATED CONTROLLERS MUST CALL THIS FUNCTION, before upgrade to angular 1.8 its code was called via constructor
    // which is depricated in 1.6 see: https://docs.angularjs.org/guide/migration#migrating-from-1-5-to-1-6

    this.listenForTicketChange();
    this.ticketChanged({});
  }

  $onDestroy() {
    this.unbindListener();
  }

  unbindListener() {
    if (this.cancelListeners) {
      _.forEach(this.cancelListeners, (cl) => cl());
      this.cancelListeners = [];
    }
  }

  listenForTicketChange() {
    this.cancelListeners.push(
      this.ticketService.registerForChange(
        this.onChange.bind(this),
        this.aidRequest.id,
      ),
    );
  }

  onChange(type, data) {
    const { ChangeTypes } = this.ticketService;
    switch (type) {
      case ChangeTypes.Ticket:
        this.ticketChanged(data);
        break;
      case ChangeTypes.ViewStatus:
        this.viewStatusChanged(data);
        break;
    }
  }

  ticketChanged(newAidRequestData) {
    const updates = this.isFeatureActive(
      this.FeatureNames.FF_SPLIT_BY_SWITCH_PRODUCTS,
    )
      ? {
        ...newAidRequestData,
        product: this.$stateParams.product,
      }
      : newAidRequestData;

    const newTicketData = this.ticketService.updateTicket(
      this.aidRequest,
      updates,
    );
    _.assign(this, newTicketData);
  }

  viewStatusChanged(data) {
    this.viewStatusChangedApplier = () => {
      this.viewStatus = this.ticketService.ViewStatus.Custom;
      this.viewStatusOptions = data;
      this.viewStatusChangedApplier = null;
    };
    if (!this.transitionInProgress) {
      this.viewStatusChangedApplier();
    }
  }

  setViewStatus() {
    this.viewStatus = this.ticketService.getViewStatus(
      this.routes,
      this.ticket,
    );
  }

  navigateTo(view) {
    const state = this.ticketService.ticketFlowService.getRouteForTicket(
      this.ticket,
      view,
    );
    this.go(state);
  }

  goToAnotherDetailView(state, data) {
    this.transitionInProgress = true;
    this.go(state, data, { silent: true }).then(this.transitioned.bind(this));
  }

  transitioned() {
    this.transitionInProgress = false;
    if (this.viewStatusChangedApplier) {
      return this.viewStatusChangedApplier();
    }
    this.setViewStatus();
  }
}
